export const getFilter = (allDepartments) => [
  {
    label: 'Status',
    data: [
      {
        id: 0,
        name: 'Pending',
      },
      {
        id: 1,
        name: 'Approved',
      },
      {
        id: 2,
        name: 'Rejected',
      },
    ],
    name: 'status',
    keys: {
      id: 'id',
      value: 'name',
    },
  },
  {
    label: 'Department',
    data: [{ dept_id: 0, dept_name: 'All' }, ...allDepartments],
    keys: { id: 'dept_id', value: 'dept_name' },
    name: 'department',
  },
];
